var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "mobile-nav-icon",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.481 13.101C23.0133 13.101 25.0894 11.0612 25.0894 8.5228C25.0894 5.98438 23.0361 3.94458 20.481 3.94458",
    stroke: "#8B8B8D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69775 13.1008C3.16542 13.1008 1.08936 15.1406 1.08936 17.679C1.08936 20.2175 3.1426 22.2573 5.69775 22.2573",
    stroke: "#8B8B8D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79331 13.1008H5.69824",
    stroke: "#8B8B8D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4809 13.1008H19.4771",
    stroke: "#8B8B8D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4816 3.94458H7.08984",
    stroke: "#8B8B8D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69824 22.2349H19.2953",
    stroke: "#8B8B8D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21488 6.80031C5.80244 6.80031 7.08942 5.52176 7.08942 3.94459C7.08942 2.36742 5.80244 1.08887 4.21488 1.08887C2.62731 1.08887 1.34033 2.36742 1.34033 3.94459C1.34033 5.52176 2.62731 6.80031 4.21488 6.80031Z",
    stroke: "#8B8B8D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1352 19.379C16.6379 19.379 19.4775 16.5581 19.4775 13.0783C19.4775 9.59852 16.6379 6.77759 13.1352 6.77759C9.63249 6.77759 6.79297 9.59852 6.79297 13.0783C6.79297 16.5581 9.63249 19.379 13.1352 19.379Z",
    stroke: "#8B8B8D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1695 25.0903C23.757 25.0903 25.044 23.8118 25.044 22.2346C25.044 20.6575 23.757 19.3789 22.1695 19.3789C20.5819 19.3789 19.2949 20.6575 19.2949 22.2346C19.2949 23.8118 20.5819 25.0903 22.1695 25.0903Z",
    stroke: "#8B8B8D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6479 13.849H13.5453V10.1094",
    stroke: "#8B8B8D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.d5b1ee7df3b6b2b81220fa923138bffd.svg";
export { ForwardRef as ReactComponent };